import axios from 'axios'

export default () => {
  return axios.create({
    baseURL: process.env.API_ROOT + '/v1',
    headers: {
      Authorization: `Bearer ` + localStorage.getItem('token'),
      'Access-Control-Allow-Origin': '*',
      'content-type': 'application/json'
    },
    params: {
      companyId: !parseInt(localStorage.getItem('CompanyId')) ? undefined : parseInt(localStorage.getItem('CompanyId'))
    },
  })
}
